import _styled from '@emotion/styled/base';
import { DEPTH, ZIndex } from '@tablekit/theme';
import { mediaQuery, getThemeValue } from '@tablekit/utils';
import { panelThemeNamespace, panelClassicTheme } from '../themes.js';
import { PanelPosition } from '../types.js';
var slideIn = '0.3s cubic-bezier(0.77, 0.2, 0.05, 1)';

var StaticContainer = /*#__PURE__*/_styled('div', process.env.NODE_ENV === "production" ? {
  shouldForwardProp: function shouldForwardProp(prop) {
    return ['height', 'isOpen', 'position', 'width'].indexOf(prop) === -1;
  },
  target: "e16lur150"
} : {
  shouldForwardProp: function shouldForwardProp(prop) {
    return ['height', 'isOpen', 'position', 'width'].indexOf(prop) === -1;
  },
  target: "e16lur150",
  label: "StaticContainer"
})("display:flex;flex-direction:column;position:fixed!important;transition:transform ", slideIn, ";", function (_ref) {
  var position = _ref.position;
  return "".concat(position, ": 0;");
}, ";", function (_ref2) {
  var isOpen = _ref2.isOpen,
      position = _ref2.position;

  if (position === PanelPosition.Bottom) {
    return "\n      left: 0;\n      transform: ".concat(isOpen ? 'translateY(0)' : 'translateY(110%)');
  }

  return "\n    top: 0;\n    transform: ".concat(isOpen ? 'translateX(0)' : "translateX(".concat(position === PanelPosition.Left ? '-' : '', "110%)"));
}, ";", mediaQuery('width', function (value) {
  return "width: ".concat(value || '100%');
}), ";", mediaQuery('height', function (value) {
  return "height: ".concat(value || '100%');
}), ";", DEPTH.FIXED, ";background-color:", getThemeValue("".concat(panelThemeNamespace, ".backgroundColor"), panelClassicTheme.backgroundColor), ";z-index:", ZIndex.Sidenav, ";box-shadow:0 6px 16px 0 rgba(0, 0, 0, 0.1);");

StaticContainer.displayName = 'StaticPanelContainer';
export { StaticContainer };
